import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from 'environments/environment';

type PublishedFor = 'staging' | 'kiosk' | 'production';

/**
 * Закрывает разделы, которые поднимаются только на проде: на staging- и
 * kiosk-сборках маршрут не активируется.
 *
 * Регистрация через providedIn обязательна: роутер достаёт гард из инжектора
 * при активации маршрута, и без провайдера навигация падает с NullInjectorError.
 */
@Injectable({ providedIn: 'root' })
export class ShutdownKioskGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of((environment.publishedFor as PublishedFor) === 'production');
  }
}
